import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Users, Home, Layers, Truck, Pocket, CreditCard, RefreshCw, CheckSquare, Inbox, ShoppingBag, FileText, Shield, MapPin, Tool } from "react-feather";
import MasterDetailEmptyState from "../components/layout/MasterDetailEmptyState";
import SignIn from "../features/auth/pages/SignIn";
import ServiceFeedbackPage from "../features/serviceFeedback/pages/ServiceFeedbackPage";
import Dashboard from "../features/dashboard/pages/Dashboard";
import ChangePasswordPage from "../features/profile/pages/ChangePasswordPage";
import RolesList from "../features/roles/pages/RolesList";
import DesignationsList from "../features/designations/pages/DesignationsList";
import UsersList from "../features/users/pages/UsersList";
import UserDetail from "../features/users/pages/UserDetail";
import DepartmentsPage from "../features/masters/departments/DepartmentsPage";
import HrDesignationsPage from "../features/masters/designations/HrDesignationsPage";
import TaxPage from "../features/masters/tax/TaxPage";
import DeductionsPage from "../features/masters/deductions/DeductionsPage";
import HolidaysPage from "../features/masters/holidays/HolidaysPage";
import AreasPage from "../features/masters/areas/AreasPage";
import ServiceTypesPage from "../features/masters/serviceTypes/ServiceTypesPage";
import ChecklistItemsPage from "../features/masters/technicalChecklistItems/ChecklistItemsPage";
import WorkSplitView from "../features/technical/pages/WorkSplitView";
import WorkDetail from "../features/technical/pages/WorkDetail";
import PendingAssignmentPage from "../features/technical/pages/PendingAssignmentPage";
import DutyListPage from "../features/technical/pages/DutyListPage";
import TechnicianDutyReportPage from "../features/technical/pages/TechnicianDutyReportPage";
import ControlRoomBoardPage from "../features/alarms/pages/ControlRoomBoardPage";
import AlarmResponseDetailPage from "../features/alarms/pages/AlarmResponseDetailPage";
import AlarmResponseReportPage from "../features/alarms/pages/AlarmResponseReportPage";
import MobileUnitsPage from "../features/alarms/pages/MobileUnitsPage";
import CustomerSplitView from "../features/masters/customers/pages/CustomerSplitView";
import CustomerForm from "../features/masters/customers/pages/CustomerForm";
import GuardingAssignmentsPage from "../features/masters/customers/pages/GuardingAssignmentsPage";
import BulkGuardsPage from "../features/masters/customers/pages/BulkGuardsPage";
import CustomerFieldVisitsPage from "../features/masters/customers/pages/CustomerFieldVisitsPage";
import CustomerLocationsMapPage from "../features/masters/customers/pages/CustomerLocationsMapPage";
import CustomerQrStickersPage from "../features/masters/customers/pages/CustomerQrStickersPage";
import ProductSplitView from "../features/masters/products/pages/ProductSplitView";
import ProductForm from "../features/masters/products/pages/ProductForm";
import ProductGroupsPage from "../features/masters/products/pages/ProductGroupsPage";
import EmployeeSplitView from "../features/masters/employees/pages/EmployeeSplitView";
import EmployeeForm from "../features/masters/employees/pages/EmployeeForm";
import EmployeeRemarksPage from "../features/masters/employees/pages/EmployeeRemarksPage";
import VehicleSplitView from "../features/masters/vehicles/pages/VehicleSplitView";
import VehicleForm from "../features/masters/vehicles/pages/VehicleForm";
import VehicleMaintenanceReportPage from "../features/masters/vehicles/reports/pages/VehicleMaintenanceReportPage";
import FuelCardsPage from "../features/fuel/pages/FuelCardsPage";
import VehicleFuelSetupPage from "../features/fuel/pages/VehicleFuelSetupPage";
import FuelRefillsPage from "../features/fuel/pages/FuelRefillsPage";
import FuelTransactionsPage from "../features/fuel/pages/FuelTransactionsPage";
import FuelExceptionsPage from "../features/fuel/pages/FuelExceptionsPage";
import FuelReportsPage from "../features/fuel/pages/FuelReportsPage";
import FuelMonthlySummaryPage from "../features/fuel/pages/FuelMonthlySummaryPage";
import {
  FUEL_EXCEPTIONS_READ,
  FUEL_OFFICE_READ,
  FUEL_REFILL_READ,
  FUEL_TRANSACTION_READ,
} from "../features/fuel/useFuelPermissions";
import OneStopPage from "../features/reports/oneStop/pages/OneStopPage";
import ReconciliationReportPage from "../features/reports/reconciliation/ReconciliationReportPage";
import CollectionsListPage from "../features/collections/pages/CollectionsListPage";
import CollectorListsPage from "../features/collections/pages/CollectorListsPage";
import CollectorPerformancePage from "../features/collections/pages/CollectorPerformancePage";
import LpoList from "../features/stock/lpo/pages/LpoList";
import LpoForm from "../features/stock/lpo/pages/LpoForm";
import LpoDetail from "../features/stock/lpo/pages/LpoDetail";
import PendingVehicleRequests from "../features/stock/lpo/pages/PendingVehicleRequests";
import StockInList from "../features/stock/stock-in/pages/StockInList";
import StockInForm from "../features/stock/stock-in/pages/StockInForm";
import StockInDetail from "../features/stock/stock-in/pages/StockInDetail";
import StockOutList from "../features/stock/stock-out/pages/StockOutList";
import StockOutForm from "../features/stock/stock-out/pages/StockOutForm";
import StockOutDetail from "../features/stock/stock-out/pages/StockOutDetail";
import StockReturnList from "../features/stock/returns/pages/StockReturnList";
import StockReturnForm from "../features/stock/returns/pages/StockReturnForm";
import StockReturnDetail from "../features/stock/returns/pages/StockReturnDetail";
import StockAdjustmentList from "../features/stock/adjustments/pages/StockAdjustmentList";
import StockAdjustmentForm from "../features/stock/adjustments/pages/StockAdjustmentForm";
import StockAdjustmentDetail from "../features/stock/adjustments/pages/StockAdjustmentDetail";
import StockBalancesPage from "../features/stock/balances/pages/StockBalancesPage";
import StockMovementReportPage from "../features/stock/movementReport/pages/StockMovementReportPage";
import FundSplitView from "../features/pettycash/funds/pages/FundSplitView";
import FundForm from "../features/pettycash/funds/pages/FundForm";
import VoucherSplitView from "../features/pettycash/vouchers/pages/VoucherSplitView";
import VoucherCreate from "../features/pettycash/vouchers/pages/VoucherCreate";
import VoucherDetail from "../features/pettycash/vouchers/pages/VoucherDetail";
import RefillSplitView from "../features/pettycash/refills/pages/RefillSplitView";
import RefillCreate from "../features/pettycash/refills/pages/RefillCreate";
import RefillDetail from "../features/pettycash/refills/pages/RefillDetail";
import ReconciliationSplitView from "../features/pettycash/reconciliations/pages/ReconciliationSplitView";
import ReconciliationCreate from "../features/pettycash/reconciliations/pages/ReconciliationCreate";
import ReconciliationDetail from "../features/pettycash/reconciliations/pages/ReconciliationDetail";
import CategoriesPage from "../features/pettycash/categories/pages/CategoriesPage";
import LedgerPage from "../features/pettycash/ledger/pages/LedgerPage";
import SummaryReportPage from "../features/pettycash/reports/pages/SummaryReportPage";
import VoucherRegisterReportPage from "../features/pettycash/reports/pages/VoucherRegisterReportPage";
import VoucherReturnsPage from "../features/pettycash/returns/pages/VoucherReturnsPage";
import EnquirySplitView from "../features/sales/enquiries/pages/EnquirySplitView";
import EnquiryForm from "../features/sales/enquiries/pages/EnquiryForm";
import EnquiryDetail from "../features/sales/enquiries/pages/EnquiryDetail";
import OrderSplitView from "../features/sales/orders/pages/OrderSplitView";
import OrderDetail from "../features/sales/orders/pages/OrderDetail";
import SalesDashboardPage from "../features/sales/dashboard/pages/SalesDashboardPage";
import CommissionsPage from "../features/sales/commissions/pages/CommissionsPage";
import ClientVisitsReportPage from "../features/sales/clientVisits/pages/ClientVisitsReportPage";
import PrototypeSplitView from "../features/sales/quotations/prototypes/pages/PrototypeSplitView";
import PrototypeForm from "../features/sales/quotations/prototypes/pages/PrototypeForm";
import PrototypeDetail from "../features/sales/quotations/prototypes/pages/PrototypeDetail";
import QuotationSplitView from "../features/sales/quotations/pages/QuotationSplitView";
import PendingDeploymentSplitView from "../features/guarding/pages/PendingDeploymentSplitView";
import PendingDeploymentDetail from "../features/guarding/components/PendingDeploymentDetail";
import SupervisorAreaSplitView from "../features/guarding/pages/SupervisorAreaSplitView";
import SupervisorAreaDetail from "../features/guarding/components/SupervisorAreaDetail";
import GuardLookupPage from "../features/guarding/pages/GuardLookupPage";
import GuardDutyListPage from "../features/guarding/pages/GuardDutyListPage";
import PettyCashOverviewPage from "../features/pettycash/overview/pages/PettyCashOverviewPage";
import OfficeAttendancePostsPage from "../features/guarding/pages/OfficeAttendancePostsPage";
import AttendanceDashboardPage from "../features/guarding/pages/AttendanceDashboardPage";
import LeaveManagementPage from "../features/leave/pages/LeaveManagementPage";
import NewAmcPage from "../features/amc/pages/NewAmcPage";
import QuotationDetail from "../features/sales/quotations/pages/QuotationDetail";
import QuotationEditPage from "../features/sales/quotations/pages/QuotationEditPage";
import FeedbackInbox from "../features/feedback/pages/FeedbackInbox";
import SettingsPage from "../features/settings/pages/SettingsPage";
import AccessGuidePage from "../features/admin/AccessGuidePage";
import AppLayout from "../components/layout/AppLayout";
import ProtectedRoute from "./ProtectedRoute";
import PermissionRoute from "./PermissionRoute";
import { paths } from "./paths";

/*
  Who may reach an LPO screen (2026-09-18).

  These five routes were all gated on Stock.ViewLpo alone, which had two bad
  consequences for anyone holding an LPO action permission without it:

    - reported live by user 'vinay' (TEXASTRACK): holds Stock.CreateLpo and
      Stock.PrintLpo but not Stock.ViewLpo, so the LPOs menu never appeared and
      he could not list, open or print any LPO - "not able to select lpo";
    - stockLpoNew was gated the same way, so a Stock.CreateLpo holder could not
      even open the CREATE form - the one thing their permission is for.

  Mirrors StockController.LpoReadPolicy exactly; keep the two in step. Each
  ACTION inside these pages stays gated on its own permission, so widening who
  may open them grants nobody a new action.
*/
const LPO_READ_CODES = [
  "Stock.ViewLpo",
  "Stock.CreateLpo",
  "Stock.EditLpo",
  "Stock.ApproveLpo",
  "Stock.CancelLpo",
  "Stock.PrintLpo",
  "Stock.CreateStockIn",
  "Stock.CreateDirectStockIn",
];

const AppRoutes = () => (
  <Routes>
    <Route path={paths.signin} element={<SignIn />} />
    {/* Public, deliberately OUTSIDE ProtectedRoute - the reader is a customer with no
        login. Authority is the unguessable token in the URL. */}
    <Route path={paths.serviceFeedback()} element={<ServiceFeedbackPage />} />

    <Route element={<ProtectedRoute />}>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Navigate to={paths.dashboard} replace />} />
        <Route path={paths.dashboard} element={<Dashboard />} />
        {/* Own password - signed-in only, no permission (the API side is plain [Authorize]). */}
        <Route path={paths.changePassword} element={<ChangePasswordPage />} />
        <Route
          path={paths.roles}
          element={
            <PermissionRoute code="Admin.ManageRoles">
              <RolesList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.designations}
          element={
            <PermissionRoute code="Admin.ManageDesignations">
              <DesignationsList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.feedback}
          element={
            <PermissionRoute code="Admin.ManageFeedback">
              <FeedbackInbox />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.settings}
          element={
            <PermissionRoute code="Settings.ManageIntegrations">
              <SettingsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.accessGuide}
          element={
            <PermissionRoute code={["Admin.ManageUsers", "Admin.ManageRoles", "Admin.ManageDesignations"]}>
              <AccessGuidePage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.users}
          element={
            <PermissionRoute code="Admin.ManageUsers">
              <UsersList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.userDetail()}
          element={
            <PermissionRoute code="Admin.ManageUsers">
              <UserDetail />
            </PermissionRoute>
          }
        />

        {/* HR master screens - each page has its own {Page}.View permission
            (handoff §13.3); write-gating (.Create/.Edit) happens in-page. */}
        <Route
          path={paths.hrDepartments}
          element={
            <PermissionRoute code="Departments.View">
              <DepartmentsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.hrDesignations}
          element={
            <PermissionRoute code="Designations.View">
              <HrDesignationsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.hrTax}
          element={
            <PermissionRoute code="Tax.View">
              <TaxPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.hrDeductions}
          element={
            <PermissionRoute code="Deductions.View">
              <DeductionsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.hrHolidays}
          element={
            <PermissionRoute code="Holidays.View">
              <HolidaysPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.hrAreas}
          element={
            <PermissionRoute code="Area.View">
              <AreasPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.serviceTypes}
          element={
            <PermissionRoute code={["Sales.ViewServiceTypes", "Sales.ManageServiceTypes"]}>
              <ServiceTypesPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.technicalChecklistItems}
          element={
            <PermissionRoute code="Technical.ManageChecklistItems">
              <ChecklistItemsPage />
            </PermissionRoute>
          }
        />
        {/* Technical Work (2026-09-08). Gated on ANY of the four view codes:
            the three granular ones don't just decide whether the endpoint
            answers, they restrict which rows come back, so an
            Installations-only viewer gets a legitimately shorter list rather
            than a 403. */}
        <Route
          path={paths.technicalWork}
          element={
            <PermissionRoute
              code={["Technical.View", "Technical.ViewComplaints", "Technical.ViewServiceVisits", "Technical.ViewInstallations"]}
            >
              <WorkSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={Tool} text="Select a job from the list to view its details" />}
          />
          <Route path=":recordGuid" element={<WorkDetail />} />
        </Route>
        <Route
          path={paths.technicalPendingAssignment}
          element={
            <PermissionRoute code="Technical.AssignToTechnical">
              <PendingAssignmentPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.technicalDutyList}
          element={
            <PermissionRoute
              code={["Technical.View", "Technical.ViewComplaints", "Technical.ViewServiceVisits", "Technical.ViewInstallations"]}
            >
              <DutyListPage />
            </PermissionRoute>
          }
        />
        {/* Alarm Response / Control Room (2026-09-17, Batch177). The board and
            detail are the control room's; Alarms.View holders can read them too.
            A car's own login (Alarms.Respond only) works in the mobile app. */}
        <Route
          path={paths.alarmBoard}
          element={
            <PermissionRoute code={["Alarms.Dispatch", "Alarms.View"]}>
              <ControlRoomBoardPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.alarmResponseDetail()}
          element={
            <PermissionRoute code={["Alarms.Dispatch", "Alarms.View"]}>
              <AlarmResponseDetailPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.alarmReport}
          element={
            <PermissionRoute code={["Alarms.Dispatch", "Alarms.View"]}>
              <AlarmResponseReportPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.alarmMobileUnits}
          element={
            <PermissionRoute code="Alarms.ManageUnits">
              <MobileUnitsPage />
            </PermissionRoute>
          }
        />
        {/* Master-detail split-view (design concept approved 2026-08-28,
            second module after Employee Master) - CustomerSplitView renders
            the compact list pane once and an <Outlet/> for whichever of
            these children is active. Guarding/Bulk Entry/Field Visits nest
            under the same :branchId/:custId as Edit, since they're all
            per-customer sub-pages sharing that identity - none of the 4 page
            components themselves changed, only how they're routed. */}
        <Route
          path={paths.customers}
          element={
            <PermissionRoute code={["Customers.View", "Customers.Create", "Customers.Edit"]}>
              <CustomerSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={Home} text="Select a customer from the list to view details" />}
          />
          <Route path="new" element={<CustomerForm />} />
          <Route path=":branchId/:custId/edit" element={<CustomerForm />} />
          <Route path=":branchId/:custId/guarding" element={<GuardingAssignmentsPage />} />
          <Route path=":branchId/:custId/bulk-guards" element={<BulkGuardsPage />} />
          <Route
            path=":branchId/:custId/field-visits"
            element={
              <PermissionRoute code="Customers.ViewLocation">
                <CustomerFieldVisitsPage />
              </PermissionRoute>
            }
          />
        </Route>
        {/* Locations Map stays a normal flat page - it's a global map across
            customers, not a per-customer detail view. */}
        <Route
          path={paths.customerLocationsMap}
          element={
            <PermissionRoute code="Customers.ViewLocation">
              <CustomerLocationsMapPage />
            </PermissionRoute>
          }
        />
        {/* One-time QR sticker run (Batch181) - flat page, like the map. */}
        <Route
          path={paths.customerQrStickers}
          element={
            <PermissionRoute code={["Customers.View", "Customers.Create", "Customers.Edit"]}>
              <CustomerQrStickersPage />
            </PermissionRoute>
          }
        />
        {/* Master-detail split-view, third module on this pattern after
            Employee Master and Customers - ProductSplitView renders the
            compact list pane once and an <Outlet/> for whichever child is
            active. Product Groups stays a normal flat page below. */}
        <Route
          path={paths.products}
          element={
            <PermissionRoute code={["Products.View", "Products.Create", "Products.Edit"]}>
              <ProductSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={Layers} text="Select a product from the list to view details" />}
          />
          <Route path="new" element={<ProductForm />} />
          <Route path=":recordGuid/edit" element={<ProductForm />} />
        </Route>
        <Route
          path={paths.productGroups}
          element={
            <PermissionRoute code="Products.View">
              <ProductGroupsPage />
            </PermissionRoute>
          }
        />
        {/* Master-detail split-view pilot (design concept approved 2026-08-28,
            tested against Employee Master since Petty Cash has no React
            implementation to pilot against) - EmployeeSplitView renders the
            compact list pane once and an <Outlet/> for whichever of these
            children is active, instead of each being its own flat full-page
            route like every other module still is. */}
        <Route
          path={paths.employees}
          element={
            <PermissionRoute code="Employees.View">
              <EmployeeSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={Users} text="Select an employee from the list to view details" />}
          />
          <Route path="new" element={<EmployeeForm mode="new" />} />
          <Route path=":recordGuid/edit" element={<EmployeeForm mode="edit" />} />
          <Route path=":recordGuid/promote" element={<EmployeeForm mode="promote" />} />
        </Route>
        {/* Remarks stays a normal flat page, deliberately out of scope for
            this pilot - it isn't part of the list/detail pair being tested. */}
        <Route
          path={paths.employeeRemarks}
          element={
            <PermissionRoute code="Employees.ViewRemarks">
              <EmployeeRemarksPage />
            </PermissionRoute>
          }
        />
        {/* Master-detail split-view, fourth module on this pattern after
            Employee Master, Customers, and Products. */}
        <Route
          path={paths.vehicles}
          element={
            <PermissionRoute code="Vehicles.View">
              <VehicleSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={Truck} text="Select a vehicle from the list to view details" />}
          />
          <Route path="new" element={<VehicleForm />} />
          <Route path=":vehicleId/edit" element={<VehicleForm />} />
        </Route>
        {/* Vehicle Maintenance Report/History (2026-09-03) - nav-grouped
            under Reports > Vehicles, same "route stays with its owning
            module" convention as Stock Movement Report / Petty Cash's own
            report routes below. */}
        <Route
          path={paths.vehicleMaintenanceReport}
          element={
            <PermissionRoute code="Vehicles.ViewRequests">
              <VehicleMaintenanceReportPage />
            </PermissionRoute>
          }
        />
        {/* Fuel Management (2026-09-19). Each gate is the any-of list of the
            API policy behind the page's own GETs (OR semantics) - writes are
            gated in-page on the single Fuel.* action code. */}
        <Route
          path={paths.fuelCards}
          element={
            <PermissionRoute code={FUEL_OFFICE_READ}>
              <FuelCardsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.fuelVehicleSetup}
          element={
            <PermissionRoute code={FUEL_OFFICE_READ}>
              <VehicleFuelSetupPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.fuelRefills}
          element={
            <PermissionRoute code={FUEL_REFILL_READ}>
              <FuelRefillsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.fuelTransactions}
          element={
            <PermissionRoute code={FUEL_TRANSACTION_READ}>
              <FuelTransactionsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.fuelExceptions}
          element={
            <PermissionRoute code={FUEL_EXCEPTIONS_READ}>
              <FuelExceptionsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.fuelReports}
          element={
            <PermissionRoute code="Fuel.ViewReports">
              <FuelReportsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.fuelMonthlySummary}
          element={
            <PermissionRoute code="Fuel.ViewReports">
              <FuelMonthlySummaryPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.technicianDutyReport}
          element={
            <PermissionRoute
              code={["Technical.View", "Technical.ViewComplaints", "Technical.ViewServiceVisits", "Technical.ViewInstallations"]}
            >
              <TechnicianDutyReportPage />
            </PermissionRoute>
          }
        />

        {/* One Stop report (2026-09-10, Batch151). Own dedicated permission
            under the REPORTS module - Reports.OneStop, no .View suffix, the
            convention Batch66's Reports.StockMovement set for a read-only
            report. Deliberately NOT gated on each module's own permission:
            the endpoint scopes every row to the caller's own branches, and
            a manager who may see the report may see all of it. */}
        <Route
          path={paths.oneStopReport}
          element={
            <PermissionRoute code="Reports.OneStop">
              <OneStopPage />
            </PermissionRoute>
          }
        />

        {/* Transaction Reconciliation (Batch174). Its own permission because it
            exposes per-item COST and MARGIN, which the other reports do not. */}
        <Route
          path={paths.transactionReconciliationReport}
          element={
            <PermissionRoute code="Reports.TransactionReconciliation">
              <ReconciliationReportPage />
            </PermissionRoute>
          }
        />

        {/* Collections list (2026-09-10) - the drill-down target One Stop
            needed. Read-only; writes stay in the Flutter app. */}
        <Route
          path={paths.collections}
          element={
            <PermissionRoute code="Collections.View">
              <CollectionsListPage />
            </PermissionRoute>
          }
        />
        {/* Collector lists + performance (Batch189). The list screen opens for
            either permission (array = OR) - a report reader may look at who
            owns whom, only ManageAllocation can change it. */}
        <Route
          path={paths.collectorLists}
          element={
            <PermissionRoute code={["Collections.ManageAllocation", "Collections.ViewPerformance"]}>
              <CollectorListsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.collectorPerformance}
          element={
            <PermissionRoute code="Collections.ViewPerformance">
              <CollectorPerformancePage />
            </PermissionRoute>
          }
        />

        {/* Stock Management - own top-level module, against
            TexasAlarms.Api's src/Stock module. */}
        <Route
          path={paths.stockLpos}
          element={
            <PermissionRoute code={LPO_READ_CODES}>
              <LpoList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockLpoPendingVehicleRequests}
          element={
            /* Two audiences now (2026-09-10): whoever raises the LPO
               (Stock.CreateLpo) and whoever approves the request in the first
               place (Vehicles.ApproveRequest). OR semantics - gating on
               Stock.CreateLpo alone locked approving managers out of the only
               screen where they can approve, which is the whole point of the
               change. Each section inside the page is gated on its own
               permission, so neither audience sees the other's actions. */
            <PermissionRoute code={["Stock.CreateLpo", "Vehicles.ApproveRequest"]}>
              <PendingVehicleRequests />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockLpoNew}
          element={
            <PermissionRoute code={LPO_READ_CODES}>
              <LpoForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockLpoEdit()}
          element={
            <PermissionRoute code={LPO_READ_CODES}>
              <LpoForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockLpoDetail()}
          element={
            <PermissionRoute code={LPO_READ_CODES}>
              <LpoDetail />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockIn}
          element={
            <PermissionRoute code="Stock.ViewStockIn">
              <StockInList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockInNew}
          element={
            <PermissionRoute code="Stock.ViewStockIn">
              <StockInForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockInDetail()}
          element={
            <PermissionRoute code="Stock.ViewStockIn">
              <StockInDetail />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockOut}
          element={
            <PermissionRoute code="Stock.ViewStockOut">
              <StockOutList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockOutNew}
          element={
            <PermissionRoute code="Stock.ViewStockOut">
              <StockOutForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockOutDetail()}
          element={
            <PermissionRoute code="Stock.ViewStockOut">
              <StockOutDetail />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockReturns}
          element={
            <PermissionRoute code="Stock.ViewReturn">
              <StockReturnList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockReturnNew}
          element={
            <PermissionRoute code="Stock.ViewReturn">
              <StockReturnForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockReturnDetail()}
          element={
            <PermissionRoute code="Stock.ViewReturn">
              <StockReturnDetail />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockAdjustments}
          element={
            <PermissionRoute code="Stock.ViewAdjustment">
              <StockAdjustmentList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockAdjustmentNew}
          element={
            <PermissionRoute code="Stock.ViewAdjustment">
              <StockAdjustmentForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockAdjustmentDetail()}
          element={
            <PermissionRoute code="Stock.ViewAdjustment">
              <StockAdjustmentDetail />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockBalances}
          element={
            <PermissionRoute code="Stock.ViewBalance">
              <StockBalancesPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockMovementReport}
          element={
            <PermissionRoute code="Reports.StockMovement">
              <StockMovementReportPage />
            </PermissionRoute>
          }
        />

        {/* Petty Cash - own top-level module, against TexasAlarms.Api's
            src/PettyCash module. Fund/Voucher/Refill/Reconciliation use the
            master-detail split-view (per direct instruction, unlike Stock's
            flat routes above) - each SplitView renders the compact list
            pane once and an <Outlet/> for whichever child is active.
            Categories/Ledger/Reports stay flat pages below, same as Stock
            Balances/Movement Report. */}
        <Route
          path={paths.pettyCashFunds}
          element={
            <PermissionRoute code="PettyCash.ViewBalance">
              <FundSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={Pocket} text="Select a fund from the list to view details" />}
          />
          <Route path="new" element={<FundForm />} />
          <Route path=":fundId/edit" element={<FundForm />} />
        </Route>
        <Route
          path={paths.pettyCashVouchers}
          element={
            <PermissionRoute code="PettyCash.View">
              <VoucherSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={CreditCard} text="Select a voucher from the list to view details" />}
          />
          <Route path="new" element={<VoucherCreate />} />
          <Route path=":recordGuid" element={<VoucherDetail />} />
        </Route>
        <Route
          path={paths.pettyCashRefills}
          element={
            <PermissionRoute code="PettyCash.View">
              <RefillSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={RefreshCw} text="Select a refill request from the list to view details" />}
          />
          <Route path="new" element={<RefillCreate />} />
          <Route path=":recordGuid" element={<RefillDetail />} />
        </Route>
        <Route
          path={paths.pettyCashReconciliations}
          element={
            <PermissionRoute code="PettyCash.View">
              <ReconciliationSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={CheckSquare} text="Select a reconciliation from the list to view details" />}
          />
          <Route path="new" element={<ReconciliationCreate />} />
          <Route path=":recordGuid" element={<ReconciliationDetail />} />
        </Route>
        <Route
          path={paths.pettyCashCategories}
          element={
            <PermissionRoute code="PettyCash.View">
              <CategoriesPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.pettyCashLedger}
          element={
            <PermissionRoute code="PettyCash.ViewLedger">
              <LedgerPage />
            </PermissionRoute>
          }
        />
        {/* Voucher Returns (Batch168) - for whoever takes change back (RecordReturn)
            and whoever oversees the funds (ViewAll). */}
        <Route
          path={paths.pettyCashReturns}
          element={
            <PermissionRoute code={["PettyCash.RecordReturn", "PettyCash.ViewAll"]}>
              <VoucherReturnsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.pettyCashSummaryReport}
          element={
            <PermissionRoute code="PettyCash.ViewReports">
              <SummaryReportPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.pettyCashVoucherRegister}
          element={
            <PermissionRoute code="PettyCash.ViewReports">
              <VoucherRegisterReportPage />
            </PermissionRoute>
          }
        />
        {/* Petty Cash Overview (2026-09-15) - Ledger + Register + Summary on one
            page. Either permission opens it; each section checks its own. */}
        <Route
          path={paths.pettyCashOverview}
          element={
            <PermissionRoute code={["PettyCash.ViewLedger", "PettyCash.ViewReports"]}>
              <PettyCashOverviewPage />
            </PermissionRoute>
          }
        />

        {/* Sales Monitoring - own top-level module, against
            TexasAlarms.Api's src/Sales module. Enquiries/Orders use the
            master-detail split-view, same shape as Petty Cash's Voucher/
            Refill blocks above. Upcoming Deployments moved to its own
            Guarding module below (Phase 1, 2026-09-02). */}
        <Route
          path={paths.salesEnquiries}
          element={
            <PermissionRoute code={["Sales.View", "Sales.ViewAll", "Sales.CreateEnquiry", "Sales.ApproveEnquiry", "Sales.ApproveWithExternalQuotation", "Sales.BookForOthers", "Sales.UploadQuotation"]}>
              <EnquirySplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={Inbox} text="Select an enquiry from the list to view details" />}
          />
          <Route
            path="new"
            element={
              <PermissionRoute code="Sales.CreateEnquiry">
                <EnquiryForm mode="new" />
              </PermissionRoute>
            }
          />
          <Route path=":recordGuid" element={<EnquiryDetail />} />
          <Route
            path=":recordGuid/resubmit"
            element={
              <PermissionRoute code="Sales.CreateEnquiry">
                <EnquiryForm mode="resubmit" />
              </PermissionRoute>
            }
          />
        </Route>
        <Route
          path={paths.salesOrders}
          element={
            <PermissionRoute code={["Sales.View", "Sales.ViewAll", "Sales.CreateConfirmedOrder", "Sales.CloseOrder", "Sales.BookForOthers", "Sales.ManageOperations"]}>
              <OrderSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={ShoppingBag} text="Select an order from the list to view details" />}
          />
          <Route
            path="new-confirmed"
            element={
              <PermissionRoute code="Sales.CreateConfirmedOrder">
                <EnquiryForm mode="directConfirm" />
              </PermissionRoute>
            }
          />
          <Route path=":recordGuid" element={<OrderDetail />} />
        </Route>
        <Route
          path={paths.salesCommissions}
          element={
            <PermissionRoute code="Sales.ManageCommission">
              <CommissionsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.salesDashboard}
          element={
            <PermissionRoute code="Sales.ViewReports">
              <SalesDashboardPage />
            </PermissionRoute>
          }
        />
        {/* Client Visits (Batch182). Any-of, matching navConfig: whoever
            records visits in the app can look them up here, and
            Sales.ViewAllClientVisits is what widens it past their own. */}
        <Route
          path={paths.salesClientVisits}
          element={
            <PermissionRoute
              code={["Sales.ViewAllClientVisits", "Sales.ViewClientVisits", "Sales.LogClientVisit"]}
            >
              <ClientVisitsReportPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.quotationPrototypes}
          element={
            <PermissionRoute code="Quotation.ManagePrototype">
              <PrototypeSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={Layers} text="Select a prototype from the list to view details" />}
          />
          <Route path=":recordGuid" element={<PrototypeDetail />} />
          <Route path=":recordGuid/edit" element={<PrototypeForm />} />
        </Route>
        <Route
          path={paths.quotations}
          element={
            <PermissionRoute code={["Quotation.View", "Quotation.ViewAll", "Quotation.Create", "Quotation.Edit", "Quotation.EditApproved", "Quotation.Approve", "Quotation.Send", "Quotation.Cancel"]}>
              <QuotationSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={FileText} text="Select a quotation from the list to view details" />}
          />
          <Route path=":recordGuid" element={<QuotationDetail />} />
          <Route path=":recordGuid/edit" element={<QuotationEditPage />} />
        </Route>

        {/* Guarding - own top-level module, Phase 1 (2026-09-02). Both
            master-detail split-views, per direct instruction. */}
        <Route
          path={paths.guardingPendingDeployments}
          element={
            <PermissionRoute code="Deployment.View">
              <PendingDeploymentSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={Shield} text="Select an order from the list to record its guard deployment" />}
          />
          <Route path=":recordGuid" element={<PendingDeploymentDetail />} />
        </Route>
        <Route
          path={paths.guardingSupervisorAreas}
          element={
            <PermissionRoute code="Deployment.ManageSupervisorAreas">
              <SupervisorAreaSplitView />
            </PermissionRoute>
          }
        >
          <Route
            index
            element={<MasterDetailEmptyState icon={MapPin} text="Select an employee from the list to manage their assigned areas" />}
          />
          <Route path=":employeeRecordGuid" element={<SupervisorAreaDetail />} />
        </Route>
        {/* Guard Lookup (2026-09-05) - React port of the Flutter Attendance
            module's own screen. Plain page, not a split-view (search-then-
            browse, no per-row detail route). Attendance's own endpoint,
            policy Attendance.Mark|Attendance.View - PermissionRoute's
            `code` accepts an array for exactly this OR case. */}
        <Route
          path={paths.guardingGuardLookup}
          element={
            <PermissionRoute code={["Attendance.Mark", "Attendance.View"]}>
              <GuardLookupPage />
            </PermissionRoute>
          }
        />

        {/* Duty List (2026-09-14) - web version of the WinForms Duty List report,
            linked from Guard Lookup by tabs. Same Attendance endpoint family and
            the same Attendance.Mark|Attendance.View policy. */}
        <Route
          path={paths.guardingDutyList}
          element={
            <PermissionRoute code={["Attendance.Mark", "Attendance.View"]}>
              <GuardDutyListPage />
            </PermissionRoute>
          }
        />

        {/* Office Attendance Posts (2026-09-15, Batch173) - manage the carrier slot
            each office employee's kiosk punch is credited to. Matches the backend's
            "Attendance.ManagePosts|Attendance.View" policy: the new code is the real
            one, and Attendance.View is accepted so existing attendance managers can
            use the page before Batch173b seeds that permission anywhere. */}
        <Route
          path={paths.guardingOfficeAttendancePosts}
          element={
            <PermissionRoute code={["Attendance.ManagePosts", "Attendance.View"]}>
              <OfficeAttendancePostsPage />
            </PermissionRoute>
          }
        />

        {/* Attendance Dashboard (2026-09-09) - React port of the Flutter screen.
            Same Attendance.Mark|Attendance.View policy as Guard Lookup above, so
            the same array form of `code`. A plain supervisor holding only
            Attendance.Mark gets the page, scoped server-side to their own areas. */}
        <Route
          path={paths.guardingAttendanceDashboard}
          element={
            <PermissionRoute code={["Attendance.Mark", "Attendance.View"]}>
              <AttendanceDashboardPage />
            </PermissionRoute>
          }
        />

        {/* Leave Management (2026-09-05) - web port of the legacy frm_Leave/
            Frm_Bulk_leave screens, merged into one page. Plain page, not a
            split-view - the grid and the Mark Leave form live on the same
            screen. Save itself is gated client-side (useCanMarkLeave) since
            viewing and marking are two separate permissions. */}
        <Route
          path={paths.leaveManagement}
          element={
            <PermissionRoute code="Leave.View">
              <LeaveManagementPage />
            </PermissionRoute>
          }
        />

        {/* AMC & Warranty (2026-09-07) - own top-level module per direct
            instruction. ONE permission gates view and manage together, so there
            is no separate Amc.ViewEquipment code to grant. */}
        <Route
          path={paths.amcNew}
          element={
            <PermissionRoute code={["Amc.ManageContracts", "Amc.ManageEquipment"]}>
              <NewAmcPage />
            </PermissionRoute>
          }
        />
      </Route>
    </Route>

    <Route path="*" element={<Navigate to={paths.dashboard} replace />} />
  </Routes>
);

export default AppRoutes;
